/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import TitleBar from './TitleBar';
import PersonalDataView from './PersonalData';
import AccesData from './AccessData';
import Directions from './Directions';
import Subcriptions from './Subcriptions';
import SignOut from './SignOut';
import DatosForm from './forms/datosForm';
import {
  AccessData,
  DirectionData,
  FamiliarData,
  PersonalData,
  PrefijoPais,
  TiposDocumento,
  TiposVia,
} from '../../types/PersonalData';
import DirectionForm from './forms/direccionForm';
import FacturacionForm from './forms/facturacionForm';
import AccesoForm from './forms/accesoForm';
import BajaForm from './forms/bajaForm';
import EncuestaForm from './forms/encuestaForm';
import GraciasForm from './forms/graciasForm';
import { StorageHelper } from '../../utils/StorageHelper';
import { StylesSwapHelper } from '../../utils/StylesSwapHelper';
import ModalBajaSocioConsumidor from './ModalBajaSocioConsumidor';
import { MisDatosHelper } from './MisDatosHelper';
import { CookieHelper } from '../../utils/CookieHelper';
import { AuthContextType } from '../../types/Types';
import PreferenciaModVales from './PreferenciaModVales';
import { useAppStore } from '../../store/AppContext';
import ContactDataView from './ContactDataView';
import ContactEmailForm from './forms/contactEmailForm';
import { useMisDatosStore } from './context/MisDatos.context';
import Telefono1Form from './forms/telefono1Form';
import ServicioV2PForm from './forms/servicioV2PForm';
import DataService from '../../services/MisDatosService';
import useAPIError from '../../hooks/useAPIError';

interface Props {
  showChangePass?: boolean;
  showChangeMail?: boolean;
  showBaja?: boolean;
  showFamily: boolean;
  dataUser: AuthContextType;
  handlerModal: any;
  personalData: PersonalData;
  getPersonalData: any;
  familiarData: FamiliarData;
  getFamiliarData: any;
  setUserForm: any;
  setPassForm: any;
  accessData: AccessData;
  load: boolean;
  promiseApi: boolean;
  getData: any;
  prefijosPaises: PrefijoPais[];
  setVisiblePersonalData: any;
  directionData: DirectionData[];
  setDirectionData: any;
  tipo: string;
  setTipo: any;
  retrieveDirections: any;
  setOnLoadDirectionModal: any;
  isDigital: boolean;
  setIsDigital: any;
  isSocioEroski: boolean;
  setIsSocioEroski: any;
  setShowBajaForm: any;
  showBajaProcessModal: boolean;
  setShowBajaProcessModal: any;
  visiblePersonalData: boolean;
  setPersonalData: any;
  setFamiliarData: any;
  tiposDocumento: TiposDocumento[];
  tiposVia: TiposVia[];
  prefijosPaisesMixtos: PrefijoPais[];
  onLoadDirectionModal: any;
  directionDataNew: DirectionData;
  userForm: boolean;
  passForm: boolean;
  showBajaForm: boolean;
  setShowOpinionForm: any;
  showOpinionForm: boolean;
  setShowGraciasForm: any;
  showGraciasForm: boolean;
  showAccessData: boolean;
  cuentaBloqueada: boolean;
}
const MisDatosEroski: FC<Props> = (props) => {
  const {
    showFamily,
    dataUser,
    handlerModal,
    personalData,
    getPersonalData,
    getFamiliarData,
    familiarData,
    setUserForm,
    setPassForm,
    accessData,
    load,
    promiseApi,
    getData,
    prefijosPaises,
    setVisiblePersonalData,
    directionData,
    setDirectionData,
    tipo,
    setTipo,
    retrieveDirections,
    setOnLoadDirectionModal,
    isDigital,
    setIsDigital,
    isSocioEroski,
    setIsSocioEroski,
    setShowBajaForm,
    showBajaProcessModal,
    setShowBajaProcessModal,
    visiblePersonalData,
    setPersonalData,
    setFamiliarData,
    tiposDocumento,
    tiposVia,
    prefijosPaisesMixtos,
    onLoadDirectionModal,
    directionDataNew,
    userForm,
    passForm,
    showBajaForm,
    setShowOpinionForm,
    showOpinionForm,
    setShowGraciasForm,
    showGraciasForm,
    showAccessData,
    cuentaBloqueada,
  } = props;

  const { t } = useTranslation();
  const { addError } = useAPIError();
  const origen = 'mis-datos';
  const misDatosHelper = new MisDatosHelper();
  const { titular, isGibraltar } = dataUser.user;
  const {
    showModalContactEmailForm,
    getModalTelefono1Form,
    showModalTelefono1Form,
    getModalContactEmailForm,
    showModalServicioV2PForm,
    showModalContactEmail,
  } = useMisDatosStore();
  const isApp = dataUser.user.isApp === 'true';
  const isEcommerceBot = StorageHelper.isEcommerceBot();
  StylesSwapHelper.swapStyleIfApp(isApp || isEcommerceBot);

  const updateFamiliarData = (familiarDataUpdate: FamiliarData) => {
    DataService.updateFamiliarData(familiarDataUpdate).then(
      (responseBajaServicio) => {
        if (responseBajaServicio.data.error === true) {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        }
        getFamiliarData();
      },
    );
  };

  useEffect(() => {
    getModalTelefono1Form();
    if (showModalTelefono1Form) {
      StorageHelper.removeshowModalTelefono1();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModalTelefono1Form]);

  useEffect(() => {
    getModalContactEmailForm();
    if (showModalContactEmailForm) {
      StorageHelper.removeshowModalContactEmail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModalContactEmailForm]);

  useEffect(() => {
    const source = StorageHelper.getCambioEmailComInv();
    if (source) {
      showModalContactEmail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <TitleBar />

      <section className="o-section--large section-misdatos">
        <div className="container" id="section-misdatos">
          <PersonalDataView
            loadModal={handlerModal}
            personalData={personalData}
            isFamilyData={showFamily}
            getData={getPersonalData}
            familiarData={familiarData}
            promiseApi={promiseApi}
          />
          <ContactDataView
            loadModal={handlerModal}
            personalData={personalData}
            isFamilyData={showFamily}
            getData={getPersonalData}
            familiarData={familiarData}
            promiseApi={promiseApi}
          />
          <AccesData
            setUserForm={setUserForm}
            setPassForm={setPassForm}
            emailAcceso={accessData.emailAcceso}
            dobleVerificacion={accessData.dobleVerificacion}
            showAccessData={showAccessData}
            load={load}
            promiseApi={promiseApi}
            cargarPersonalData={getPersonalData}
            cargarData={getData}
            prefijosPaises={prefijosPaises}
            setShowPersonalData={setVisiblePersonalData}
            origenData={origen}
          />

          <Directions
            directionData={directionData}
            setDirectionData={setDirectionData}
            tipo={tipo}
            setTipo={setTipo}
            cargarDirecciones={retrieveDirections}
            setOnLoad={setOnLoadDirectionModal}
            cuentaBloqueada={cuentaBloqueada}
          />

          <Subcriptions tipo={showFamily} />

          {titular && !isGibraltar ? <PreferenciaModVales /> : ''}

          <SignOut
            isDigital={isDigital}
            setIsDigital={setIsDigital}
            isEroski={isSocioEroski}
            setIsEroski={setIsSocioEroski}
            setVisible={setShowBajaForm}
            tipoSocio={personalData.tipoSocioConsumidor}
            showModal={showBajaProcessModal}
            setShowModal={setShowBajaProcessModal}
          />
        </div>
      </section>

      {showModalContactEmailForm && (
        <ContactEmailForm
          personalData={personalData}
          dobleVerificacion={accessData.dobleVerificacion}
        />
      )}
      {showModalTelefono1Form && (
        <Telefono1Form
          personalData={personalData}
          cargarData={getPersonalData}
        />
      )}
      {showModalServicioV2PForm && (
        <ServicioV2PForm personalData={personalData} cargarData={getData} />
      )}
      <DatosForm
        visible={visiblePersonalData}
        setShow={setVisiblePersonalData}
        personalData={personalData}
        setPersonalData={setPersonalData}
        familiarData={familiarData}
        isFamilyData={showFamily}
        setFamiliarData={setFamiliarData}
        cargarPersonalData={getPersonalData}
        updateFamiliarData={updateFamiliarData}
        cargarAccessData={getData}
        prefijosPaises={prefijosPaises}
        tiposDocumento={tiposDocumento}
      />
      {directionData &&
        directionData.map((d) =>
          d.tipoDireccion !== -1 && d.tipoDireccion === 2 ? (
            <FacturacionForm
              key={d.idDireccion}
              directionData={d}
              isAdd={false}
              cargarDirecciones={retrieveDirections}
              tiposVia={tiposVia}
            />
          ) : (
            <DirectionForm
              key={d.idDireccion}
              directionData={d}
              isAdd={false}
              cargarDirecciones={retrieveDirections}
              prefijosPaises={prefijosPaisesMixtos}
              onLoad={onLoadDirectionModal}
              setOnLoad={setOnLoadDirectionModal}
            />
          ),
        )}
      <DirectionForm
        directionData={directionDataNew}
        isAdd
        cargarDirecciones={retrieveDirections}
        prefijosPaises={prefijosPaisesMixtos}
        onLoad={onLoadDirectionModal}
        setOnLoad={setOnLoadDirectionModal}
      />
      <FacturacionForm
        directionData={directionDataNew}
        isAdd
        cargarDirecciones={retrieveDirections}
        tiposVia={tiposVia}
      />

      <AccesoForm
        userForm={userForm}
        setUserForm={setUserForm}
        passForm={passForm}
        setPassForm={setPassForm}
        accessEmail={accessData.emailAcceso}
        cargarData={getData}
        personalData={personalData}
      />

      <BajaForm
        visible={showBajaForm}
        setVisible={setShowBajaForm}
        setShowOpinionForm={setShowOpinionForm}
        isDigital={isDigital}
        isSocioEroski={isSocioEroski}
        tipoSocio={personalData.tipoSocioConsumidor}
      />

      <EncuestaForm
        visible={showOpinionForm}
        setVisible={setShowOpinionForm}
        isDigital={isDigital}
        isEroski={isSocioEroski}
        setShowGraciasForm={setShowGraciasForm}
        setShowBajaForm={setShowBajaForm}
      />

      <GraciasForm visible={showGraciasForm} isDigital={isDigital} />

      {misDatosHelper.testSocioConsumidor(
        personalData.tipoSocioConsumidor,
        CookieHelper.isBloqueada(),
      ) && (
        <ModalBajaSocioConsumidor
          isBig
          isSmall={false}
          textCentered={false}
          showModal={showBajaProcessModal}
          setShowModal={setShowBajaProcessModal}
          title={t('datos.baja.unsuscribe-as-consumer-partner')}
          textHTMLContent={
            t('datos.baja.unsuscribe-as-consumer-partner-body1-modal') +
            t('datos.baja.unsuscribe-as-consumer-partner-body2-modal') +
            t('datos.baja.unsuscribe-as-consumer-partner-body3-modal')
          }
          doAceptar={() => null}
          doClose={() => null}
          showCancel
          acceptButtonTextKey={t('datos.baja.accept')}
        />
      )}
    </>
  );
};

export default MisDatosEroski;
